var tapiProxyBaseUrl = "https://rtx-tapi-proxy.azurewebsites.net/api/tapi";
var rtxWheelConfiguratorApiBase = tapiProxyBaseUrl + "/RTXWheelConfigurator";

var RideStylerKEY = '';
var url = "";
var acesID = '';
var partNumber = '';
var colorVehicle = '000000';
var WheelsCount = 0;
var wheelsSRC = '';
var Handle = '';
var countPrev = 0;
var countNext = 0;
var TrimDescription = "";
var arrayOptions = [];
var currArrayOptions = [];
var DiameterSelected = 0;
var CurrAngle = 'Angle';
var hasAngle = false;
var hasSize = false;

function fetchTapiJson(url) {
  return fetch(url, {
    method: "GET",
    headers: {
      "accept": "application/json"
    }
  }).then(function(res) {
    if (!res.ok) {
      throw new Error("TAPI proxy error: " + res.status);
    }

    return res.json();
  });
}

function buildFitmentRtxUrl() {
  const vehicleYear = document.getElementById("vehicle-year");
  const vehicleMake = document.getElementById("vehicle-make");
  const vehicleModel = document.getElementById("vehicle-model");
  const vehicleSubModel = document.getElementById("vehicle-submodel");
  const vehicleSubModelOptions = document.getElementById("vehicle-submodeloptions");

  var url =
    rtxWheelConfiguratorApiBase +
    "/FitmentRTX/" +
    encodeURIComponent(vehicleYear.value) + "/" +
    encodeURIComponent(vehicleMake.value) + "/" +
    encodeURIComponent(vehicleModel.value) + "/" +
    encodeURIComponent(vehicleSubModel.value);

  if (vehicleSubModelOptions.value && vehicleSubModelOptions.value !== "Select Option") {
    url += "?VehicleOption=" + encodeURIComponent(vehicleSubModelOptions.value);
  }

  return url;
}

function validateScrollBar(){ 
  setTimeout(function(){ 
    var div = $('#contentCarrousel');
    var calculateRightScrollWidth = div[0].scrollWidth - div.scrollLeft();
    if(div.scrollLeft() == 0){
      $('#moveLeft svg').addClass('disabledSvg');
      $('#moveLeft svg').removeClass('svg');
    }
    if((div.scrollLeft() == 0) && (calculateRightScrollWidth == 1080)){
      $('#moveLeft').css('display','none');
      $('#moveRight').css('display','none');
    }else{
      $('#moveLeft').css('display','block');
      $('#moveRight').css('display','block');
    }
    
    const ChangeAS = document.getElementById("ChangeAS");
      console.log(hasAngle);
      console.log(hasSize);
    if((hasAngle == false) || (hasSize == false)){
      ChangeAS.style.display = "none";
    }else{
      ChangeAS.style.display = "block";
      console.log('enter');
    }
    
    }, 1000);
}

//Load Make
function loadMake(){
  const vehicleYear = document.getElementById("vehicle-year");
  const vehicleMake = document.getElementById("vehicle-make");
  const vehicleModel = document.getElementById("vehicle-model");
  const vehicleSubModel = document.getElementById("vehicle-submodel");
  const vehicleSubModelOptions = document.getElementById("vehicle-submodeloptions");
  
  const vehicleSearch = document.getElementById("vehicle-search");

  
  
  vehicleMake.innerHTML = ""; 
  var option = document.createElement("option");
  option.value = "Select Make";
  option.innerText = "Select Make";
  vehicleMake.append(option);
  vehicleMake.classList.remove("disabled_select");
  
  vehicleModel.innerHTML = ""; 
  var option = document.createElement("option");
  option.value = "Select Model";
  option.innerText = "Select Model";
  vehicleModel.append(option);
  vehicleModel.classList.add("disabled_select");
  
  vehicleSubModel.innerHTML = ""; 
  var option = document.createElement("option");
  option.value = "Select SubModel";
  option.innerText = "Select SubModel";
  vehicleSubModel.append(option);
  vehicleSubModel.classList.add("disabled_select");
  
  vehicleSubModelOptions.innerHTML = ""; 
  var option = document.createElement("option");
  option.value = "Select Option";
  option.innerText = "Select Option";
  vehicleSubModelOptions.append(option);
  vehicleSubModelOptions.classList.add("disabled_select");
  
  vehicleSearch.classList.add("disabled_select");
  
  fetchTapiJson(
    rtxWheelConfiguratorApiBase +
    "/Vehicle/Makes/" +
    encodeURIComponent(vehicleYear.value)
  )
  .then(data => {
    data.forEach(Data => {
      if (Data != null) {
        var option = document.createElement("option");
        option.value = Data;
        option.innerText = Data;
        vehicleMake.append(option);
      }
    });
  })
  .catch(error => {
    console.error("[RTX Configurator] loadMake failed:", error);
  });
  
}

//Load Model
function loadModel(){
  const vehicleYear = document.getElementById("vehicle-year");
  const vehicleMake = document.getElementById("vehicle-make");
  const vehicleModel = document.getElementById("vehicle-model");
  const vehicleSubModel = document.getElementById("vehicle-submodel");
  const vehicleSubModelOptions = document.getElementById("vehicle-submodeloptions");

  
  const vehicleSearch = document.getElementById("vehicle-search");
  
  vehicleModel.innerHTML = ""; 
  var option = document.createElement("option");
  option.value = "Select Model";
  option.innerText = "Select Model";
  vehicleModel.append(option);
  vehicleModel.classList.remove("disabled_select");
  
  vehicleSubModel.innerHTML = ""; 
  var option = document.createElement("option");
  option.value = "Select SubModel";
  option.innerText = "Select SubModel";
  vehicleSubModel.append(option);
  vehicleSubModel.classList.add("disabled_select");
  
  vehicleSubModelOptions.innerHTML = ""; 
  var option = document.createElement("option");
  option.value = "Select Option";
  option.innerText = "Select Option";
  vehicleSubModelOptions.append(option);
  vehicleSubModelOptions.classList.add("disabled_select");
  
  vehicleSearch.classList.add("disabled_select");
  
  fetchTapiJson(
    rtxWheelConfiguratorApiBase +
    "/Vehicle/Models/" +
    encodeURIComponent(vehicleYear.value) + "/" +
    encodeURIComponent(vehicleMake.value)
  )
  .then(data => {
    data.forEach(Data => {
      const option = document.createElement("option");
      option.value = Data;
      option.innerText = Data;
      vehicleModel.append(option);
    });
  })
  .catch(error => {
    console.error("[RTX Configurator] loadModel failed:", error);
  });
}

//Load Submodel
function loadSubModel(){ 
  const vehicleYear = document.getElementById("vehicle-year");
  const vehicleMake = document.getElementById("vehicle-make");
  const vehicleModel = document.getElementById("vehicle-model");
  const vehicleSubModel = document.getElementById("vehicle-submodel");
  const vehicleSubModelOptions = document.getElementById("vehicle-submodeloptions");

  const vehicleSearch = document.getElementById("vehicle-search");
  
  vehicleSubModel.innerHTML = ""; 
  var option = document.createElement("option");
  option.value = "Select SubModel";
  option.innerText = "Select SubModel";
  vehicleSubModel.append(option);
  vehicleSubModel.classList.remove("disabled_select");
  
  vehicleSubModelOptions.innerHTML = ""; 
  var option = document.createElement("option");
  option.value = "Select Option";
  option.innerText = "Select Option";
  vehicleSubModelOptions.append(option);
  vehicleSubModelOptions.classList.add("disabled_select");
  
  vehicleSearch.classList.add("disabled_select");
  
  fetchTapiJson(
    rtxWheelConfiguratorApiBase +
    "/VehicleSubModels/" +
    encodeURIComponent(vehicleYear.value) + "/" +
    encodeURIComponent(vehicleMake.value) + "/" +
    encodeURIComponent(vehicleModel.value)
  )
  .then(data => {
    data.forEach(Data => {
      const option = document.createElement("option");
      option.value = Data;
      option.innerText = Data;
      vehicleSubModel.append(option);
    });
  })
  .catch(error => {
    console.error("[RTX Configurator] loadSubModel failed:", error);
  });
}

//Load Submodel Options
function loadSubModelOptions(){
  const vehicleYear = document.getElementById("vehicle-year");
  const vehicleMake = document.getElementById("vehicle-make");
  const vehicleModel = document.getElementById("vehicle-model");
  const vehicleSubModel = document.getElementById("vehicle-submodel");
  const vehicleSubModelOptions = document.getElementById("vehicle-submodeloptions");
  const vehicleSearch = document.getElementById("vehicle-search");

  vehicleSubModelOptions.innerHTML = ""; 

  var option = document.createElement("option");
  option.value = "Select Option";
  option.innerText = "Select Option";
  vehicleSubModelOptions.append(option);

  vehicleSubModelOptions.classList.remove("disabled_select");
  vehicleSearch.classList.remove("disabled_select");

  fetchTapiJson(
    rtxWheelConfiguratorApiBase +
    "/VehicleOptions/" +
    encodeURIComponent(vehicleYear.value) + "/" +
    encodeURIComponent(vehicleMake.value) + "/" +
    encodeURIComponent(vehicleModel.value) + "/" +
    encodeURIComponent(vehicleSubModel.value)
  )
  .then(data => {
    var count = 0;

    data.forEach(Data => {
      if (Data != null) {
        const option = document.createElement("option");
        option.value = Data;
        option.innerText = Data;
        vehicleSubModelOptions.append(option);
        count++;
      }
    });

    if (count === 0) {
      vehicleSearch.classList.remove("disabledBTN");
      vehicleSubModelOptions.classList.add("disabledSelect");
    } else if (count === 1) {
      vehicleSearch.classList.remove("disabledBTN");
      vehicleSubModelOptions.classList.add("disabledSelect");
    } else {
      vehicleSearch.classList.add("disabledBTN");
      vehicleSubModelOptions.classList.remove("disabledSelect");
    }
  })
  .catch(error => {
    console.error("[RTX Configurator] loadSubModelOptions failed:", error);
  });
}

//Get vehicle image with wheels
function getImgRS(partNumberX, acesID, colorVehicle,trimData){
  
  if(acesID != ''){
  const contentVehicle = document.getElementById("contentVehicle");
  const notAvailableText = document.getElementById("notAvailableText");
  const colorChange = document.getElementById("colorChange");
  const diameterContent = document.getElementById("diameterContent");
  const modelText = document.getElementById("modelText");
  const contentBackground = document.getElementById("contentBackground");
  
  contentVehicle.innerHTML = "";
  var count = 0;
  
    var urlRideStyler = 'https://api.ridestyler.net/Vehicle/GetDescriptions?key=' + RideStylerKEY + '&ReferenceFilters%5b0%5d.Type=1&ReferenceFilters%5b0%5d.Field=16&ReferenceFilters%5b0%5d.Value=' + acesID;

	const dataYear = fetch(urlRideStyler, {

      method: 'GET',
      headers: {      
        "Authorization": RideStylerKEY
      }
    })
    .then(res => res.json())
    .then(data => {
            
      if(data.Descriptions[0].HasAngledImage){ hasAngle = true; }
      else{ hasAngle = false; }
      
      if(data.Descriptions[0].HasSideImage){ hasSize = true; }
      else{ hasSize = false; }
      updateAngleImage();
      if((data.Success) && (data.Descriptions.length != 0)){
        
        if((CurrAngle == 'Side') && (hasSize == false)){ CurrAngle = 'Angle'; }
        if((CurrAngle == 'Angle') && (hasAngle == false)){ CurrAngle = 'Side'; }
        
        var urlRender = 'https://api.ridestyler.net/Wheel/CanBeRendered?key=' + RideStylerKEY + '&PartNumbers=' + partNumberX + '&VehicleConfiguration=' + data.Descriptions[0].ConfigurationID + '&Type=' + CurrAngle; 
              	
        
        var imgContent = document.createElement("img");
        imgContent.src = 'https://cdn-api.ridestyler.net/Vehicle/Render?key=' + RideStylerKEY + '&VehicleConfiguration=' + data.Descriptions[0].ConfigurationID + '&Width=480&Height=240&PaintColor=%23' + colorVehicle + '&Type=' + CurrAngle + '&WheelPartNumber='+partNumberX;
        TrimDescription = data.Descriptions[0].TrimDescription;
        data.Descriptions.forEach(descrip => {
            if(trimData == descrip.TrimDescription){
              	
    			var urlRender = 'https://api.ridestyler.net/Wheel/CanBeRendered?key=' + RideStylerKEY + '&PartNumbers=' + partNumberX + '&VehicleConfiguration=' + descrip.ConfigurationID + '&Type=' + CurrAngle; 
              	
              	TrimDescription = descrip.TrimDescription;
  				contentVehicle.innerHTML = "";
                imgContent.src = 'https://cdn-api.ridestyler.net/Vehicle/Render?key=' + RideStylerKEY + '&VehicleConfiguration=' + descrip.ConfigurationID + '&Width=480&Height=240&PaintColor=%23' + colorVehicle + '&Type=' + CurrAngle + '&WheelPartNumber='+partNumberX;
            }
            count++;
          });
        contentVehicle.append(imgContent);
        notAvailableText.style.display = "none";
        colorChange.style.display = "block";
        diameterContent.style.display = "block";
        contentBackground.style.display = "block";
		}else{
            notAvailableText.style.display = "block";
            colorChange.style.display = "none";
            diameterContent.style.display = "none";
            contentBackground.style.display = "none";
          }
      
      
      var render = fetch(urlRender, {

      method: 'GET',
      headers: {      
        "Authorization": RideStylerKEY
        }
      })
      .then(res => res.json())
      .then(data => {        
        var wheelsFitVehicle = Object.values(data.Result)[0]; 
        
        if(wheelsFitVehicle == false){
          	contentVehicle.innerHTML = "";
            notAvailableText.style.display = "block";
            colorChange.style.display = "none";
            diameterContent.style.display = "none";
            contentBackground.style.display = "none";
        }
      });
      
    })
  }
}

//Get ACES ID for use RideStyler
function getACESID(){
  const vehicleYear = document.getElementById("vehicle-year");
  const vehicleMake = document.getElementById("vehicle-make");
  const vehicleModel = document.getElementById("vehicle-model");
  const vehicleSubModel = document.getElementById("vehicle-submodel");
  const vehicleSubModelOptions = document.getElementById("vehicle-submodeloptions");
  const contentBodyVisualizer = document.getElementById("contentBodyVisualizer");
  const contentCarrousel = document.getElementById("contentCarrousel");
  const contentVehicle = document.getElementById("contentVehicle");
  const contentVehicleSection = document.getElementById("contentVehicleSection");
  const vehicleDiameters = document.getElementById("vehicleDiameters");
  const vehicleTextName = document.getElementById("vehicleTextName");
  const specificationSection = document.getElementById("specificationSection");
  const loader = document.getElementsByClassName("loader");
  const nextOption = document.getElementById("nextOption");
  const prevOption = document.getElementById("prevOption");
  const firstOption = document.getElementById("firstOption");
  const lastOption = document.getElementById("lastOption");
  const moveLeft = document.getElementById("moveLeft");
  const moveRight = document.getElementById("moveRight");
  const notAvailableCar = document.getElementById("notAvailableCar");
  const colorChange = document.getElementById("colorChange");
  const diameterContent = document.getElementById("diameterContent");
  const ChangeAS = document.getElementById("ChangeAS");
  const contentBackground = document.getElementById("contentBackground");
  
  moveLeft.style.display = "block";
  moveRight.style.display = "block";
  
  contentCarrousel.innerHTML = "";
  contentVehicle.innerHTML = "";
  contentVehicleSection.style.display = "block";
  specificationSection.style.display = "block";
  vehicleTextName.innerHTML = vehicleYear.value + ' ' + vehicleMake.value + ' ' + vehicleModel.value;
  
  var count = 0;
  var url = buildFitmentRtxUrl();
  
  fetchTapiJson(url)  
  .then(data => { data.forEach(Data => {
    console.log(Data.shopifyProductsRTX[0]);
    if(Data.shopifyProductsRTX[0] != undefined){
      console.log(Data);
    acesID = Data.acesVehicleID;
    partNumber = Data.shopifyProductsRTX[0].shopifyPartsRTX[0].partNumber;
    wheelsSRC = Data.shopifyProductsRTX[0].productImage;
    
    var currentData = Data.shopifyProductsRTX[0].shopifyPartsRTX[0];
    var node = document.createElement("LI");   
    node.value = currentData.diameter;
    if(count <= 0){
      node.id = "diameterSelected";
      updateAngleImage();
      updatePartNumberSpec(currentData.partNumber);
      updateDiameterSpec(currentData.diameter);
      updateBoltSpec(currentData.bolt, currentData.pattern1, currentData.pattern2);
      updateOffsetSpec(currentData.offset);
      updateHubBoreSpec(currentData.centerBore);
      updateSizeSpec(currentData.diameter, currentData.width);
      updateTitleSpec(Data.shopifyProductsRTX[0].vendor);
      updateSeriesSpec(Data.shopifyProductsRTX[0].series);  
      
      updateModelSpec(Data.shopifyProductsRTX[0].model);  
      updateColorSpec(Data.shopifyProductsRTX[0].finish[0].localizedValue);  
      updateProductIcons(currentData.isDirectFit,currentData.isDirectFitImage,currentData.isHubCentric,currentData.isHubCentricImage,
      currentData.isOEMCompatible,currentData.isOEMCompatibleImage,currentData.isStaggered,currentData.isStaggeredImage,
      currentData.isWinterApproved,currentData.isWinterApprovedImage);    
    }
    
    
    getImgRS(partNumber, acesID, colorVehicle, TrimDescription);
    updateModelTrim(acesID); 
    
    Data.shopifyProductsRTX.forEach(function(){
      var img = document.createElement("img");
      img.src = Data.shopifyProductsRTX[count].productImage;
      img.width = 100;
      img.height = 100;
      img.alt = Data.shopifyProductsRTX[count].shopifyPartsRTX[0].partNumber;
      if(count <= 0){
        img.classList.add("wheels-on-car");
        updateImgProduct(Data.shopifyProductsRTX[count].productImage);   
        updateTitleProduct(Data.shopifyProductsRTX[count].handle);
        Handle = Data.shopifyProductsRTX[count].handle;
        var countPart = 0;
        arrayOptions = [];
        Data.shopifyProductsRTX[count].shopifyPartsRTX.forEach(productsPart => {
          countPart++;
          arrayOptions.push(productsPart);
          currArrayOptions = arrayOptions;
          
        });
        countPrev = 1;
        countNext = countPart;
        firstOption.innerText = countPrev;
        lastOption.innerText = countNext;
		prevOption.rel = 0;

        if(countPart > 1){
          nextOption.classList.remove("btnDisabled");
          nextOption.rel = 1;
        }else{
          nextOption.classList.add("btnDisabled");
          countNext--;
          nextOption.rel = 0;
        }
      } 
      var divWheel = document.createElement("div");
      var modelWheelsText = document.createElement("label");
      modelWheelsText.id = "wheelsModelLabel";
      modelWheelsText.innerHTML = "<br/>"+Data.shopifyProductsRTX[count].model;
      divWheel.append(img);
      divWheel.append(modelWheelsText);
      
      contentCarrousel.append(divWheel);
      count++;
      WheelsCount = count;
    });
    
    vehicleDiameters.innerHTML = "";
    var clearDiameter = document.createElement("a");
    clearDiameter.value = "Clear";
    clearDiameter.innerText = "Clear";
    clearDiameter.id = "clearDiameters";
    vehicleDiameters.append(clearDiameter); 

    Data.diameterFilters.forEach( diameters => {
      var currentDiameter = document.createElement("LI");
      currentDiameter.value = diameters.diameter;
      currentDiameter.innerText = diameters.diameter + "″";
      vehicleDiameters.append(currentDiameter); 
    });
    }else{
      acesID = "";
      notAvailableCar.style.display = "block";
      colorChange.style.display = "none";
      diameterContent.style.display = "none";
      moveLeft.style.display = "none";
      moveRight.style.display = "none";
      ChangeAS.style.display = "none";
      contentBackground.style.display = "none";
      
    }
  })
});
  
  if (contentBodyVisualizer) {
    contentBodyVisualizer.style.display = 'none';
  }

  setTimeout(function(){
    if(acesID == ""){
      contentVehicle.innerHTML = "";
      var notAvailableCar = document.getElementById("notAvailableCar");
      var ChangeAS = document.getElementById("ChangeAS");
      var colorChange = document.getElementById("colorChange");
      notAvailableCar.style.display = "block";
      ChangeAS.style.display = "none";
      colorChange.style.display = "none";
      contentBackground.style.display = "none";
      diameterContent.style.display = "none";
    }else{
      var notAvailableCar = document.getElementById("notAvailableCar");
      var ChangeAS = document.getElementById("ChangeAS");
      var colorChange = document.getElementById("colorChange");
      ChangeAS.style.display = "block";
      colorChange.style.display = "block";
      contentBackground.style.display = "block";
      diameterContent.style.display = "block";
      notAvailableCar.style.display = "none";
    }
  validateScrollBar();
  }, 4000);
  
}

//Clean Search Options
function clearSearch(){
  
  const vehicleYear = document.getElementById("vehicle-year");
  const vehicleMake = document.getElementById("vehicle-make");
  const vehicleModel = document.getElementById("vehicle-model");
  const vehicleSubModel = document.getElementById("vehicle-submodel");
  const vehicleSubModelOptions = document.getElementById("vehicle-submodeloptions");
  
  vehicleMake.innerHTML = ""; 
  var option = document.createElement("option");
  option.value = "Select Make";
  option.innerText = "Select Make";
  vehicleMake.append(option);
  vehicleMake.classList.add("disabled_select");
  
  vehicleModel.innerHTML = ""; 
  var option = document.createElement("option");
  option.value = "Select Model";
  option.innerText = "Select Model";
  vehicleModel.append(option);
  vehicleModel.classList.add("disabled_select");
  
  vehicleSubModel.innerHTML = ""; 
  var option = document.createElement("option");
  option.value = "Select SubModel";
  option.innerText = "Select SubModel";
  vehicleSubModel.append(option);
  vehicleSubModel.classList.add("disabled_select");
  
  vehicleSubModelOptions.innerHTML = ""; 
  var option = document.createElement("option");
  option.value = "Select Option";
  option.innerText = "Select Option";
  vehicleSubModelOptions.append(option);
  vehicleSubModelOptions.classList.add("disabled_select");
  
  year(); 
  
} 

//Get Diameters Available
function getDiameters(wheelsSRC){
  const vehicleYear = document.getElementById("vehicle-year");
  const vehicleMake = document.getElementById("vehicle-make");
  const vehicleModel = document.getElementById("vehicle-model");
  const vehicleSubModel = document.getElementById("vehicle-submodel");
  const vehicleSubModelOptions = document.getElementById("vehicle-submodeloptions");
  const vehicleDiameters = document.getElementById("vehicleDiameters");

  var count = 0;
  var url = buildFitmentRtxUrl();

  fetchTapiJson(url)  
  .then(data => { data.forEach(Data => {

    Data.shopifyProductsRTX.forEach(function(){
      var contPart = 0;
      if(wheelsSRC == Data.shopifyProductsRTX[count].productImage){
        Data.shopifyProductsRTX[count].shopifyPartsRTX.forEach(function(){
          var dvalue = Data.shopifyProductsRTX[count].shopifyPartsRTX[contPart].diameter;
          var node = document.createElement("LI");   
          node.value = dvalue;
          if(contPart <= 0){
            node.id = "diameterSelected";
      		updateDiameterSpec(dvalue); 
            updateAngleImage();
            updateSizeSpec(dvalue,  Data.shopifyProductsRTX[count].shopifyPartsRTX[contPart].width);
            }
          contPart++;
        });
      }
      count++;
    });
  })
});
  
}

//Get Data From Diameters
function getPartNumbersFromDiameters(wheelsSRC, wheelsDiameters){
const vehicleYear = document.getElementById("vehicle-year");
  const vehicleMake = document.getElementById("vehicle-make");
  const vehicleModel = document.getElementById("vehicle-model");
  const vehicleSubModel = document.getElementById("vehicle-submodel");
  const vehicleSubModelOptions = document.getElementById("vehicle-submodeloptions");
  var count = 0;
  var url = buildFitmentRtxUrl();

  fetchTapiJson(url)  
  .then(data => { data.forEach(Data => {
    Data.shopifyProductsRTX.forEach(function(){
      if(Data.shopifyProductsRTX[count].productImage == wheelsSRC){
        var contPart = 0;
      	Data.shopifyProductsRTX[count].shopifyPartsRTX.forEach(function(){
          if(Data.shopifyProductsRTX[count].shopifyPartsRTX[contPart].diameter == wheelsDiameters){
            
            var currentData = Data.shopifyProductsRTX[count].shopifyPartsRTX[contPart];
      		updateBoltSpec(currentData.bolt, currentData.pattern1, currentData.pattern2);
          	updateOffsetSpec(currentData.offset);
            updateHubBoreSpec(currentData.centerBore);
            partNumber = currentData.partNumber;
            getImgRS(partNumber, acesID, colorVehicle, TrimDescription);
            
            updateTitleSpec(Data.shopifyProductsRTX[count].vendor);
            updateSeriesSpec(Data.shopifyProductsRTX[count].series);
            updateModelSpec(Data.shopifyProductsRTX[count].model);
      		updateColorSpec(Data.shopifyProductsRTX[count].finish[0].localizedValue);  
            
          	updateSizeSpec(currentData.diameter, currentData.width);
            
          }
          contPart++;
        });
      }
      count++;
    });
  })
});
}

//Get Data From Wheels
function getDataFromWheels(wheelsSRC, varPosition, varDiameter = 0){
  const vehicleYear = document.getElementById("vehicle-year");
  const vehicleMake = document.getElementById("vehicle-make");
  const vehicleModel = document.getElementById("vehicle-model");
  const vehicleSubModel = document.getElementById("vehicle-submodel");
  const vehicleSubModelOptions = document.getElementById("vehicle-submodeloptions");
  const nextOption = document.getElementById("nextOption");
  const prevOption = document.getElementById("prevOption");
  var count = 0;
  var url = buildFitmentRtxUrl();

  fetchTapiJson(url)  
  .then(data => { data.forEach(Data => {
    arrayOptions = [];
    Data.shopifyProductsRTX.forEach(products => { 
      if(wheelsSRC == ''){ 
      	wheelsSRC = products.productImage;
      }
      
      
      if((products.productImage == wheelsSRC) && (varDiameter == 0)){
		var currentData = products.shopifyPartsRTX[0]; 
        updateBoltSpec(currentData.bolt, currentData.pattern1, currentData.pattern2);
        updateOffsetSpec(currentData.offset);
        updateHubBoreSpec(currentData.centerBore);
        updateSizeSpec(currentData.diameter, currentData.width);
        updateDiameterSpec(currentData.diameter);
        updateAngleImage();
      updatePartNumberSpec(currentData.partNumber);
        
        updateProductIcons(currentData.isDirectFit,currentData.isDirectFitImage,currentData.isHubCentric,currentData.isHubCentricImage,
		currentData.isOEMCompatible,currentData.isOEMCompatibleImage,currentData.isStaggered,currentData.isStaggeredImage,
		currentData.isWinterApproved,currentData.isWinterApprovedImage);
        
         
        var countOptions = 0;
        products.shopifyPartsRTX.forEach(dataPart => {
            countNextOption++;
	        arrayOptions.push(dataPart); 
          	currArrayOptions = arrayOptions;
          
            if((varPosition != 0) && (countOptions == varPosition)){
          	  nextOption.rel = parseInt(varPosition) + 1;
              prevOption.rel = parseInt(varPosition) - 1;
              var currentData = arrayOptions[varPosition];
              updateBoltSpec(currentData.bolt, currentData.pattern1, currentData.pattern2);
              updateOffsetSpec(currentData.offset);
              updateHubBoreSpec(currentData.centerBore);
              updateSizeSpec(currentData.diameter, currentData.width);
              updateDiameterSpec(currentData.diameter);
              updateAngleImage();
 		     updatePartNumberSpec(currentData.partNumber);
              updateProductIcons(currentData.isDirectFit,currentData.isDirectFitImage,currentData.isHubCentric,currentData.isHubCentricImage,
              currentData.isOEMCompatible,currentData.isOEMCompatibleImage,currentData.isStaggered,currentData.isStaggeredImage,
              currentData.isWinterApproved,currentData.isWinterApprovedImage);
            }if(varPosition == 0){
          	  nextOption.rel = parseInt(varPosition) + 1;
              prevOption.rel = 0;
              var currentData = arrayOptions[0];
              updateBoltSpec(currentData.bolt, currentData.pattern1, currentData.pattern2);
              updateOffsetSpec(currentData.offset);
              updateHubBoreSpec(currentData.centerBore);
              updateSizeSpec(currentData.diameter, currentData.width);
		      updatePartNumberSpec(currentData.partNumber);
              updateDiameterSpec(currentData.diameter);
              updateAngleImage();
              updateProductIcons(currentData.isDirectFit,currentData.isDirectFitImage,currentData.isHubCentric,currentData.isHubCentricImage,
              currentData.isOEMCompatible,currentData.isOEMCompatibleImage,currentData.isStaggered,currentData.isStaggeredImage,
              currentData.isWinterApproved,currentData.isWinterApprovedImage);
            }
            countOptions++;
        });
        
        updateTitleProduct(products.handle);
        Handle = products.handle;
        updateImgProduct(products.productImage);
        updateTitleSpec(products.vendor);
        updateSeriesSpec(products.series);
        updateModelSpec(products.model);
        updateColorSpec(products.finish[0].localizedValue); 
        
      }else{
      var currentBoolPrev = false;
      var currentBoolNext = false;
        
      arrayOptions = [];
      var countNextOption = 0;
      var countOptions = 0;
      products.shopifyPartsRTX.forEach(dataPart => {
        
        if(products.productImage == wheelsSRC){  
          
          //if((varDiameter != 0) && (dataPart.diameter == varDiameter) && (partNumber == dataPart.partNumber)){
          if((varDiameter != 0) && (dataPart.diameter == varDiameter)){
            
            arrayOptions.push(dataPart);
            
            
         	currArrayOptions = arrayOptions;
            
            countNextOption++;
            
            if((varPosition != 0) && (countOptions == varPosition)){
          	  nextOption.rel = parseInt(varPosition) + 1;
              prevOption.rel = parseInt(varPosition) - 1;
              var currentData = arrayOptions[varPosition];
              updateBoltSpec(currentData.bolt, currentData.pattern1, currentData.pattern2);
              updateOffsetSpec(currentData.offset);
              updateHubBoreSpec(currentData.centerBore);
              updateSizeSpec(varDiameter, currentData.width);
   			   updatePartNumberSpec(currentData.partNumber);
              updateDiameterSpec(varDiameter);
              updateAngleImage();
              updateProductIcons(currentData.isDirectFit,currentData.isDirectFitImage,currentData.isHubCentric,currentData.isHubCentricImage,
              currentData.isOEMCompatible,currentData.isOEMCompatibleImage,currentData.isStaggered,currentData.isStaggeredImage,
              currentData.isWinterApproved,currentData.isWinterApprovedImage);
            }if(varPosition == 0){
          	  nextOption.rel = parseInt(varPosition) + 1;
              prevOption.rel = 0;
              var currentData = arrayOptions[0];
              updateBoltSpec(currentData.bolt, currentData.pattern1, currentData.pattern2);
              updateOffsetSpec(currentData.offset);
              updateHubBoreSpec(currentData.centerBore);
              updateSizeSpec(varDiameter, currentData.width);
		      updatePartNumberSpec(currentData.partNumber);
              updateDiameterSpec(varDiameter);
              updateAngleImage();
              updateProductIcons(currentData.isDirectFit,currentData.isDirectFitImage,currentData.isHubCentric,currentData.isHubCentricImage,
              currentData.isOEMCompatible,currentData.isOEMCompatibleImage,currentData.isStaggered,currentData.isStaggeredImage,
              currentData.isWinterApproved,currentData.isWinterApprovedImage);
            }
            countOptions++;
            
            updateImgProduct(products.productImage);
            updateTitleSpec(products.vendor);
        	updateSeriesSpec(products.series);
            updateModelSpec(products.model);
            updateColorSpec(products.finish[0].localizedValue); 
            
            
            updateTitleProduct(products.handle);
            Handle = products.handle;
            currentBoolNext = true;
            currentBoolPrev = true;
          }
        }
      });
      }
      
         
      if(products.productImage == wheelsSRC){
        var countPart = 0;
        var countDiameter = 0;
        
        products.shopifyPartsRTX.forEach(dataPart => {
          countPart++;
          if(dataPart.diameter == varDiameter){
          	countDiameter++;
          }
        });
        
        countNext = countPart;
        if(varDiameter != 0){
	        countNext = countDiameter;
          if(varPosition == 0){
          	countPrev = 1;
          }
        }
        
        lastOption.innerText = countNext;
        firstOption.innerText = countPrev;
        if(countPrev == countNext){
          nextOption.classList.add("btnDisabled"); 
          if(countPrev > 1){
          	prevOption.classList.remove("btnDisabled"); 
          }
        }else{
          nextOption.classList.remove("btnDisabled"); 
        }
        if(countPrev > 1){
          	prevOption.classList.remove("btnDisabled"); 
          }
      }                        
    });
      count++;
  })
});

}

//Get carrousel Wheels Image
function getWheelsImg(varDiameter){
const vehicleYear = document.getElementById("vehicle-year");
  const vehicleMake = document.getElementById("vehicle-make");
  const vehicleModel = document.getElementById("vehicle-model");
  const vehicleSubModel = document.getElementById("vehicle-submodel");
  const vehicleSubModelOptions = document.getElementById("vehicle-submodeloptions");
  const contentCarrousel = document.getElementById("contentCarrousel");
  const contentVehicle = document.getElementById("contentVehicle");
  const contentVehicleSection = document.getElementById("contentVehicleSection");
  const vehicleDiameters = document.getElementById("vehicleDiameters");
  const vehicleTextName = document.getElementById("vehicleTextName");
  const specificationSection = document.getElementById("specificationSection");
  const loader = document.getElementsByClassName("loader");
  
  contentCarrousel.innerHTML = "";
  
  var count = 0;
  var partNumberVal = '';
  var url = buildFitmentRtxUrl();

  fetchTapiJson(url)  
  .then(data => { data.forEach(Data => {
    var contPartW = 0;
    Data.shopifyProductsRTX.forEach(products => {
      products.shopifyPartsRTX.forEach(dataPart => {
        if(dataPart.diameter == varDiameter){
          if(partNumberVal != dataPart.handle){
            partNumberVal = dataPart.handle;
            var img = document.createElement("img");
            img.src = products.productImage;
            img.width = 100;
            img.height = 100;
            img.alt = dataPart.partNumber;
            
            var divWheel = document.createElement("div");
            var modelWheelsText = document.createElement("label");
            modelWheelsText.id = "wheelsModelLabel";
            modelWheelsText.innerHTML = "<br/>"+products.model;
            divWheel.append(img);
            divWheel.append(modelWheelsText);

            contentCarrousel.append(divWheel);
            
            if(contPartW <= 0){
              img.classList.add("wheels-on-car");
              wheelsSRC = products.productImage;
              updateImgProduct(products.productImage);   

              updateProductIcons(dataPart.isDirectFit,dataPart.isDirectFitImage,dataPart.isHubCentric,dataPart.isHubCentricImage,
              dataPart.isOEMCompatible,dataPart.isOEMCompatibleImage,dataPart.isStaggered,dataPart.isStaggeredImage,
              dataPart.isWinterApproved,dataPart.isWinterApprovedImage);

              updateTitleProduct(products.handle);
              Handle = products.handle;
              updateBoltSpec(dataPart.bolt, dataPart.pattern1, dataPart.pattern2);
              updateOffsetSpec(dataPart.offset);
              updateHubBoreSpec(dataPart.centerBore);
              updateTitleSpec(products.vendor);
        	  updateSeriesSpec(products.series);
              updateModelSpec(products.model);
        	  updateColorSpec(products.finish[0].localizedValue); 
              updateSizeSpec(dataPart.diameter, dataPart.width);
              updateDiameterSpec(dataPart.diameter);
              updateAngleImage();
              partNumber = dataPart.partNumber;
              getImgRS(partNumber, acesID, colorVehicle, TrimDescription);
            }
          contPartW++;
          }
      	}
      });
    });
    count++; 
  })
});

}


//Update Data Especification Start
function updateAngleImage(){
  //var angleImage = document.getElementById("changeAngle");
  var angleImage = document.getElementById("ChangeAS");
  if((CurrAngle == 'Side') && (hasAngle == false)){ angleImage.style.display = "none"; }
  if((CurrAngle == 'Angle') && (hasSize == false)){ angleImage.style.display = "none"; }
  if((hasAngle) && (hasSize)){ angleImage.style.display = "block"; }
  
}
function updateModelTrim(acesID){
  const modelText = document.getElementById("modelText");
  
  modelText.innerHTML = "";
    var urlRideStyler = 'https://api.ridestyler.net/Vehicle/GetDescriptions?key=' + RideStylerKEY + '&ReferenceFilters%5b0%5d.Type=1&ReferenceFilters%5b0%5d.Field=16&ReferenceFilters%5b0%5d.Value=' + acesID;

	const dataYear = fetch(urlRideStyler, {

      method: 'GET',
      headers: {      
        "Authorization": RideStylerKEY
      }
    })
    .then(res => res.json())
    .then(data => {
      if((data.Success) && (data.Descriptions.length != 0)){
        modelText.style.display = "block";
        data.Descriptions.forEach(description => {
          var option = document.createElement("option");
          option.value = description.TrimDescription;
          option.innerText = description.TrimDescription;
          modelText.append(option);
        });
      }else{
        modelText.style.display = "none";
      }
    });
  
}
function updateDiameterSpec(varDiameter){
  const diameterVariant = document.getElementById("diameterVariant");
  //diameterVariant.innerHTML = parseInt(varDiameter); 	
}
function updatePartNumberSpec(varPartNumber){
  const partNumberVariant = document.getElementById("partNumberVariant");
  partNumberVariant.innerHTML = varPartNumber; 	
}
function updateBoltSpec(varBolt, varPattern1, varPattern2 = null){
  const boltVariant = document.getElementById("boltVariant");
  if(varPattern2 != null){
  	boltVariant.innerHTML = parseInt(varBolt) + 'x' + varPattern1 + '/' + varPattern2; 	
  }
  else{
  	boltVariant.innerHTML = parseInt(varBolt) + 'x' + varPattern1; 	
  }
}
function updateOffsetSpec(varOffset){
  const offsetVariant = document.getElementById("offsetVariant");
  offsetVariant.innerHTML = parseInt(varOffset); 	
}
function updateHubBoreSpec(varHubBore){
  const hubBoreVariant = document.getElementById("hubBoreVariant");
  hubBoreVariant.innerHTML = varHubBore; 	
}
function updateTitleSpec(varTitle){
  const titleVariant = document.getElementById("titleVariant");
  titleVariant.innerHTML = varTitle; 	
}
function updateSeriesSpec(varSeries){
  console.log(varSeries);
  const seriesVariant = document.getElementById("seriesVariant");
  seriesVariant.innerHTML = varSeries; 	
}
function updateModelSpec(varModel){
  const modelVariant = document.getElementById("modelVariant");
  modelVariant.innerHTML = varModel; 	
}
function updateColorSpec(varColor){
  const colorVariant = document.getElementById("colorVariant");
  colorVariant.innerHTML = varColor; 	
}
function updateSizeSpec(varDiameter, varWidth){
  const sizeVariant = document.getElementById("sizeVariant");
  sizeVariant.innerHTML = parseInt(varDiameter) + 'x' + parseFloat(varWidth); 	
}
function updateImgProduct(src){
  const imgProduct = document.getElementById("imgProduct");
  var currentImg = document.createElement("img");
  currentImg.src = src;
  imgProduct.innerHTML = "";
  imgProduct.append(currentImg); 
}
function updateTitleProduct(title){
  const titleProduct = document.getElementById("titleProduct");
  titleProduct.innerHTML = title; 	
}
function updateProductIcons(DirectFit,DirectFitSRC,HubCentric,HubCentricSRC,OEMCompatible,OEMCompatibleSRC,Staggered,StaggeredSRC,WinterAproved,WinterAprovedSRC){

  const productIcons = document.getElementById("productIcons");
  productIcons.innerHTML = "";
  
  if(DirectFit){
  	var currentImg = document.createElement("img");
    currentImg.src = DirectFitSRC;
    productIcons.append(currentImg); 
  }
  if(HubCentric){
  	var currentImg = document.createElement("img");
    currentImg.src = HubCentricSRC;
    productIcons.append(currentImg); 
  }
  if(OEMCompatible){
  	var currentImg = document.createElement("img");
    currentImg.src = OEMCompatibleSRC;
    productIcons.append(currentImg); 
  }
  if(Staggered){
  	var currentImg = document.createElement("img");
    currentImg.src = StaggeredSRC;
    productIcons.append(currentImg); 
  }
  if(WinterAproved){
  	var currentImg = document.createElement("img");
    currentImg.src = WinterAprovedSRC;
    productIcons.append(currentImg); 
  }
}
//Update Data Especification End 



$( document ).ready(function() {
  
//Load year
function year(){
  const vehicleYear = $("#vehicle-year");

  fetchTapiJson(rtxWheelConfiguratorApiBase + "/Vehicle/Years")
  .then(data => { 
    data.forEach(Data => {
      if (Data != null) {
        var option = document.createElement("option");
        option.value = Data;
        option.innerText = Data;
        vehicleYear.append(option);
      }
    });
  })
  .catch(error => {
    console.error("[RTX Configurator] year failed:", error);
  });
}
  
  //Wheels Change Function
  $('#contentCarrousel').on('click','img', function(event){
    $('.loader').css("display","block");
    $target = event.target;
    partNumber = $target.alt; 
    $('#contentCarrousel img').removeClass("wheels-on-car");
    $($target).addClass("wheels-on-car");
    getDiameters($target.src);
    if($target.src != wheelsSRC){
      countPrev = 1;
      $('#firstOption').text(countPrev);
    }
    
    
    wheelsSRC = $target.src;
    
    $diameter = $('#diameterSelected').val();
    
    getDataFromWheels(wheelsSRC,0,$diameter);
    getImgRS(partNumber, acesID, colorVehicle, TrimDescription);
    
    if(countPrev == countNext){$('#nextOption').addClass('btnDisabled');}
    else{$('#nextOption').removeClass('btnDisabled');}
    
    if(countPrev > 1){$('#prevOption').removeClass('btnDisabled');}
    else{$('#prevOption').addClass('btnDisabled');}
    
    
    var diameterSelect = $('#diameterSelected').val();
    var sizeVariant = $('#sizeVariant').text();
    var sizeVariantContent = $('#sizeVariant');
    
    $('#contentVehicle').css("visibility","hidden"); 
    $('.visualizerContainer').addClass("disabledBTN");
    $('#contentCarrousel').addClass("disabledBTN");
    setTimeout(function(){ 
      $('#contentCarrousel').removeClass("disabledBTN");
      $('.visualizerContainer').removeClass("disabledBTN");
      $('#contentVehicle').css("visibility","visible"); 
      $('.loader').css("display","none"); 
      
      if(diameterSelect != null){
       updateDiameterSpec(diameterSelect);
       sizeVariantContent.text(diameterSelect + '' + sizeVariant.substring(2, sizeVariant.length));
      }
    }, 5000);
        
  }); 
  
  //Color Change Function
  $('#colorChange').on('click','li', function(event){
    $('.loader').css("display","block");
    $target = event.target;
    var colorTitle = $target.title;
    switch (colorTitle) {  
        case 'White': 
  			colorVehicle = 'FFFFFF';
            break;  
        case 'Red': 
  			colorVehicle = 'B71C1C';
            break;  
        case 'Blue': 
  			colorVehicle = '1565C0';
            break;  
        case 'Grey': 
  			colorVehicle = '757575';
            break;  
        case 'Silver': 
  			colorVehicle = 'EEEEEE';
            break;  
        case 'Yellow': 
  			colorVehicle = 'FFEA00';
            break; 
        case 'Orange': 
  			colorVehicle = 'D84315';
            break; 
        case 'Green': 
  			colorVehicle = '1B5E20';
            break; 
        case 'Beige': 
  			colorVehicle = 'FFF3E0';
            break; 
        default:
  			colorVehicle = '000000';
    	}
  	getImgRS(partNumber, acesID, colorVehicle, TrimDescription);
    $('#contentVehicle').css("visibility","hidden"); 
    $('.visualizerContainer').addClass("disabledBTN");
    $('#contentCarrousel').addClass("disabledBTN");
    setTimeout(function(){ 
      $('#contentCarrousel').removeClass("disabledBTN");
      $('.visualizerContainer').removeClass("disabledBTN");
      $('#contentVehicle').css("visibility","visible"); 
      $('.loader').css("display","none"); 
    }, 2000);
  }); 
  
  //Diameters Change Function
  $('#vehicleDiameters').on('click','li', function(event){
    $('.loader').css("display","block");
    $target = event.target.value;
    getWheelsImg($target);
    DiameterSelected = $target;
    
    $('#vehicleDiameters li').removeAttr('id');
    event.target.id = "diameterSelected";
    
    getDataFromWheels(wheelsSRC,0,$target);
    
    
    var diameterSelect = $('#diameterSelected').val(); 
    
    
    $('#contentVehicle').css("visibility","hidden"); 
    $('.visualizerContainer').addClass("disabledBTN");
    $('#contentCarrousel').addClass("disabledBTN");
    setTimeout(function(){ 
      $('#contentCarrousel').removeClass("disabledBTN");
      $('.visualizerContainer').removeClass("disabledBTN");
      $('#contentVehicle').css("visibility","visible"); 
      $('.loader').css("display","none"); 
      
    $('.wheels-on-car').click();
      
       updateDiameterSpec(diameterSelect);
    }, 4000);
    validateScrollBar();
  });  
  
  //NextOption Function
  $('#nextOption').unbind().click(function(event){
    if(countPrev < countNext){
      $('.loader').css("display","block");
      countPrev++;
      $('#firstOption').text(countPrev);
      var rel = $('#nextOption').prop('rel');
      getDataFromWheels(wheelsSRC, rel, DiameterSelected);
    
    $('#contentVehicle').css("visibility","hidden"); 
    $('.visualizerContainer').addClass("disabledBTN");
    $('#contentCarrousel').addClass("disabledBTN");
    setTimeout(function(){ 
      $('#contentCarrousel').removeClass("disabledBTN");
      $('.visualizerContainer').removeClass("disabledBTN");
      $('#contentVehicle').css("visibility","visible"); 
      $('.loader').css("display","none"); 
      partNumber = currArrayOptions[rel].partNumber;
      getImgRS(partNumber, acesID, colorVehicle, TrimDescription);
      
    }, 4000);
    }
    if(countPrev == countNext){$('#nextOption').addClass('btnDisabled');}
    else{$('#nextOption').removeClass('btnDisabled');}
    
    if(countPrev > 1){$('#prevOption').removeClass('btnDisabled');}
    else{$('#prevOption').addClass('btnDisabled');}
  });
  
  //PrevOption Function
  $('#prevOption').unbind().click(function(event){
    if(countPrev <= countNext){
      $('.loader').css("display","block");
      var rel = $('#prevOption').prop('rel');
      countPrev--;
      $('#firstOption').text(countPrev);
      getDataFromWheels(wheelsSRC, rel, DiameterSelected);
      getImgRS(partNumber, acesID, colorVehicle, TrimDescription);
    $('#contentVehicle').css("visibility","hidden"); 
    $('.visualizerContainer').addClass("disabledBTN");
    $('#contentCarrousel').addClass("disabledBTN");
    setTimeout(function(){ 
      $('#contentCarrousel').removeClass("disabledBTN");
      $('.visualizerContainer').removeClass("disabledBTN");
      $('#contentVehicle').css("visibility","visible");  
        $('.loader').css("display","none"); 
      
      partNumber = currArrayOptions[rel].partNumber;
      getImgRS(partNumber, acesID, colorVehicle, TrimDescription);
      
      
      }, 4000);
    }
    if(countPrev == countNext){$('#nextOption').addClass('btnDisabled');}
    else{$('#nextOption').removeClass('btnDisabled');}
    
    if(countPrev > 1){$('#prevOption').removeClass('btnDisabled');}
    else{$('#prevOption').addClass('btnDisabled');}
  });
  
  //Loader
  $('#vehicle-search').on('click', function(){
    $('.loader').css("display","block");
  
    $('#contentVehicle').css("visibility","hidden"); 
    $('.visualizerContainer').addClass("disabledBTN");
    $('#contentCarrousel').addClass("disabledBTN");
    setTimeout(function(){ 
      $('#contentCarrousel').removeClass("disabledBTN");
      $('.visualizerContainer').removeClass("disabledBTN");
      $('#contentVehicle').css("visibility","visible"); 
      $('.loader').css("display","none"); 
    }, 5000);
  });
  
  //Link Product
  $('#linkProduct').on('click', function(){
    window.open("../products/"+Handle, '_blank');
    //document.location.href = "../products/"+Handle;
  });
  
  //ModelChange Function
  $('#modelText').on('change', function(){
  	var myTrim = $( "#modelText option:selected" ).val(); 
    TrimDescription = myTrim;
    getImgRS(partNumber, acesID, colorVehicle, TrimDescription);
  });
  
  //Vehicle SubModel Function
  $('#vehicle-submodeloptions').on('change', function(){
  	var valData = $( "#vehicle-submodeloptions option:selected" ).val();
    if(valData != 'Select Option'){
        $('#vehicle-search').removeClass('disabledBTN');
    }else{
    	$('#vehicle-search').addClass('disabledBTN');
    }
    
  });
  
  //Scroll Move Right Function
  $('#moveRight').on('click', function(){ 
    console.log('right');
    var leftPos = $('#contentCarrousel').scrollLeft();
    $("#contentCarrousel").animate({
      scrollLeft: leftPos + 400
    }, 1000);
    
    setTimeout(function(){ 
      var div = $('#contentCarrousel');
      if(div.scrollLeft() != 0){
        $('#moveLeft svg').removeClass('disabledSvg');
        $('#moveLeft svg').addClass('svg');
      }
      
      var calculateRightScrollWidth = div[0].scrollWidth - div.scrollLeft();
      if(calculateRightScrollWidth == 1080){
        $('#moveRight svg').addClass('disabledSvg');
        $('#moveRight svg').removeClass('svg');
      }else{
        $('#moveRight svg').removeClass('disabledSvg');
        $('#moveRight svg').addClass('svg');
      }
      
    }, 1000);
  });
  
  //Scroll Move Left Function
  $('#moveLeft').on('click', function(){ 
    console.log('left');
    var leftPos = $('#contentCarrousel').scrollLeft();
    $("#contentCarrousel").animate({
      scrollLeft: leftPos - 400
    }, 1000);
    
    setTimeout(function(){ 
      var div = $('#contentCarrousel');
      if(div.scrollLeft() == 0){
        $('#moveLeft svg').addClass('disabledSvg');
        $('#moveLeft svg').removeClass('svg');
      }
      
      var calculateRightScrollWidth = div[0].scrollWidth - div.scrollLeft();
      if(calculateRightScrollWidth == 1080){
        $('#moveRight svg').addClass('disabledSvg');
        $('#moveRight svg').removeClass('svg');
      }else{
        $('#moveRight svg').removeClass('disabledSvg');
        $('#moveRight svg').addClass('svg');
      }
      
    }, 1000);
    
  });
  
  // Scrollbar Change
  $( "#contentCarrousel" ).scroll(function() {
    console.log('scroll');
    var div = $('#contentCarrousel');
      if(div.scrollLeft() == 0){
        $('#moveLeft svg').addClass('disabledSvg');
        $('#moveLeft svg').removeClass('svg');
      }else{
        $('#moveLeft svg').removeClass('disabledSvg');
        $('#moveLeft svg').addClass('svg');
      }
      
      var calculateRightScrollWidth = div[0].scrollWidth - div.scrollLeft();
      if(calculateRightScrollWidth == 1080){
        $('#moveRight svg').addClass('disabledSvg');
        $('#moveRight svg').removeClass('svg');
      }else{
        $('#moveRight svg').removeClass('disabledSvg');
        $('#moveRight svg').addClass('svg');
      }
    
        $('#moveLeft').css('display','block');
        $('#moveRight').css('display','block');
  });
  
  //Vehicle Clear Diameters Filters Function
  $('#vehicleDiameters').on('click','a', function(){
    $('#vehicleDiameters li').removeAttr('id');
  	getACESID();
    
    $('#contentVehicle').css("visibility","hidden"); 
    $('.visualizerContainer').addClass("disabledBTN");
    $('#contentCarrousel').addClass("disabledBTN");
    setTimeout(function(){ 
      $('#contentCarrousel').removeClass("disabledBTN");
      $('.visualizerContainer').removeClass("disabledBTN");
      $('#contentVehicle').css("visibility","visible"); 
      $('.loader').css("display","none"); 
    }, 4000);
    
  });
  
  //Vehicle Change Angles Function
  
  $('#AngleC').on('click', function(){ 
    
    $('.loader').css("display","block");
    
    CurrAngle = 'Angle';
    getImgRS(partNumber, acesID, colorVehicle, TrimDescription);
    
    
    $('#contentVehicle').css("visibility","hidden"); 
    $('.visualizerContainer').addClass("disabledBTN");
    $('#contentCarrousel').addClass("disabledBTN");
    setTimeout(function(){ 
      $('#SideC').removeClass("On");
      $('#AngleC').addClass("On");
      $('#contentCarrousel').removeClass("disabledBTN");
      $('.visualizerContainer').removeClass("disabledBTN");
      $('#contentVehicle').css("visibility","visible"); 
      $('.loader').css("display","none"); 
    }, 5000);
  });
  
  $('#SideC').on('click', function(){ 
    
    $('.loader').css("display","block");
    
    CurrAngle = 'Side';
    getImgRS(partNumber, acesID, colorVehicle, TrimDescription);
    
    
    $('#contentVehicle').css("visibility","hidden"); 
    $('.visualizerContainer').addClass("disabledBTN");
    $('#contentCarrousel').addClass("disabledBTN");
    setTimeout(function(){ 
      $('#SideC').addClass("On");
      $('#AngleC').removeClass("On");
      $('#contentCarrousel').removeClass("disabledBTN");
      $('.visualizerContainer').removeClass("disabledBTN");
      $('#contentVehicle').css("visibility","visible"); 
      $('.loader').css("display","none"); 
    }, 5000);
  });
  /*
  $('#changeAngle').on('click', function(){ 
    
    $('.loader').css("display","block");
    
    if(CurrAngle == 'Side'){CurrAngle = 'Angle';}
    else{CurrAngle = 'Side';}
    
    getImgRS(partNumber, acesID, colorVehicle, TrimDescription);
    
    $('#contentVehicle').css("visibility","hidden"); 
    $('.visualizerContainer').addClass("disabledBTN");
    $('#contentCarrousel').addClass("disabledBTN");
    setTimeout(function(){ 
      $('#contentCarrousel').removeClass("disabledBTN");
      $('.visualizerContainer').removeClass("disabledBTN");
      $('#contentVehicle').css("visibility","visible"); 
      $('.loader').css("display","none"); 
    }, 5000);
    
  });*/
  year();
  
});
